import { G, Path, Svg, SvgProps } from 'react-native-svg';

// Normalized to 24x24 viewBox; geometry proportionally scaled from 30x30
const WheelAngle = ({ color, ...props }: SvgProps) => (
  <Svg viewBox='0 0 24 24' fill='none' {...props}>
    {/* Scale up around the center so the drawing stays perfectly centered */}
    <G transform='translate(12 12) scale(1.25) translate(-12 -12)'>
      <Path
        stroke={color}
        strokeWidth={1.5}
        d='M15.6 20c1.988 0 3.6-3.582 3.6-8s-1.612-8-3.6-8M12 12c0 4.418-1.612 8-3.6 8S4.8 16.418 4.8 12 6.412 4 8.4 4 12 7.582 12 12Z'
      />
      <Path stroke={color} strokeWidth={1.5} d='M8.4 20c1.988 0 3.6-3.582 3.6-8s-1.612-8-3.6-8' />
      <Path
        stroke={color}
        strokeWidth={1.5}
        d='M9.6 12c0 2.651-.538 4.8-1.2 4.8S7.2 14.651 7.2 12s.538-4.8 1.2-4.8 1.2 2.149 1.2 4.8ZM8.4 4h7.2M8.4 20h7.2'
      />
      <Path stroke={color} strokeLinecap='round' strokeWidth={1.5} d='M9.6 12h-.8' />
    </G>
  </Svg>
);
export { WheelAngle };
